module.exports = __webpack_public_path__ + "static/media/uniwellbeing-logo.8283fd8e.png";